var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "push-name" }, [_c('el-input', { ref: "inputRef", staticClass: "pt-input", attrs: { "disabled": _vm.disabled, "value": _vm.inputValue }, on: { "input": _vm.handleInput }, nativeOn: { "paste": function paste($event) {
        $event.preventDefault();
      }, "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;$event.preventDefault();
      } } }, [_vm.append ? _c('template', { slot: "append" }, [_vm._v("\n      " + _vm._s('_' + _vm.append) + "\n    ")]) : _vm._e()], 2), _vm._v(" "), _vm._l(_vm.displayOptions, function (tag, index) {
    return _c('el-tag', { key: index, staticClass: "tag", class: { 'is-disabled': _vm.disabled || tag.disabled }, attrs: { "type": tag.disabled || _vm.isInclude(tag) ? 'warning' : 'info', "size": "mini" }, on: { "click": function click($event) {
          !(_vm.disabled || tag.disabled) && _vm.toggleTag(tag);
        } } }, [_vm._v("\n    " + _vm._s(tag.label) + "\n  ")]);
  })], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };